import React from "react";
import { Sliders, List, Settings } from "react-feather";
import {Business, Description, ReceiptLong} from '@mui/icons-material';
import async from "../Components/Async";


const Login = async(() => import("./../pages/Login"));
const ForgotPassword = async(() => import("./../pages/ForgotPassword"));
const Dashboard = async(() => import("./../pages/Dashboard"));
const Setting = async(() => import("./../pages/Settings"));

const ReinsuranceCompanyList = async(() => import("./../pages/ReinsuranceCompany/ReinsuranceCompanyList"));
const ReinsuranceCompanyCreate = async(() => import("./../pages/ReinsuranceCompany/ReinsuranceCompanyCreate"));
const ReinsuranceCompanyShow = async(() => import("./../pages/ReinsuranceCompany/ReinsuranceCompanyShow"));
const ReinsuranceCompanyUpdate = async(() => import("./../pages/ReinsuranceCompany/ReinsuranceCompanyUpdate"));
const ReinsuranceCompanyUpdateEmail = async(() => import("./../pages/ReinsuranceCompany/ReinsuranceCompanyUpdateEmail"));
const ReinsuranceCompanyChangePassword = async(() => import("./../pages/ReinsuranceCompany/ReinsuranceCompanyChangePassword"));

const InsuranceCompanies = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyList"));
const InsuranceCompanyShow = async(() => import("./../pages/InsuranceCompany/InsuranceCompanyShow"))
const Policies = async(() => import("./../pages/Policies/PolicyTable"));
const Report = async(() => import("./../pages/Report/report"));

const loginRoute = {
    id: "Login",
    path: "/login",
    component: Login,
    children: null
}

const forgotPasswordRoute = {
    id: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
    children: null
}

const dashboardsRoutes = {
    id: "Dashboard",
    path: "/dashboard",
    header: "",
    icon: <Sliders />,
    containsHome: true,
    component: Dashboard
};

const settingsRoute = {
    id: "Settings",
    path: "/settings",
    icon: <Settings/>,
    component: Setting
}


const reinsuranceCompaniesRoutes = {
    id: "Reinsurance Companies",
    path: "/reinsurance-companies",
    exactMatch: false,
    icon: <Business />,
    component: ReinsuranceCompanyList
};

const reinsuranceCompanyCreateRoute = {
    id: "Reinsurance Companies",
    path: "/reinsurance-companies/create",
    exactMatch: false,
    component: ReinsuranceCompanyCreate
}

const reinsuranceCompanyShowRoute = {
    id: "Reinsurance Companies",
    path: "/reinsurance-companies/show/:id",
    exactMatch: false,
    component: ReinsuranceCompanyShow
}

const reinsuranceCompanyUpdateRoute = {
    id: "Reinsurance Companies",
    path: "/reinsurance-companies/edit/:id",
    exactMatch: false,
    component: ReinsuranceCompanyUpdate
}

const reinsuranceCompanyUpdateEmailRoute = {
    id: "Reinsurance Companies",
    path: "/reinsurance-companies/edit-email/:id",
    exactMatch: false,
    component: ReinsuranceCompanyUpdateEmail
}

const reinsuranceCompanyChangePasswordRoute = {
    id: "Reinsurance Companies",
    path: "/reinsurance-companies/change-password/:id",
    exactMatch: false,
    component: ReinsuranceCompanyChangePassword
}

const insuranceCompanyRoute={
    id: "Insurance Companies",
    path: '/insurance-companies',
    exactMatch:false,
    icon: <Business />,
    component: InsuranceCompanies
}

const insuranceCompanyShowRoute = {
    id: "Insurance Companies",
    path: '/insurance-companies/show/:insurance_id/reinsurance-company/:reinsurance_id',
    exactMatch:false,
    component: InsuranceCompanyShow
}

const policiesRoute = {
    id: "Policies",
    path: "/policies",
    exactMatch: false,
    icon: <Description/>,
    component: Policies
}

const reportRoutes = {
    id: "Report",
    path: "/report",
    icon: <ReceiptLong />,
    component: Report
}

export const dashboard = [
    dashboardsRoutes,
    settingsRoute,
    reinsuranceCompaniesRoutes,
    reinsuranceCompanyCreateRoute,
    reinsuranceCompanyShowRoute,
    reinsuranceCompanyUpdateRoute,
    reinsuranceCompanyUpdateEmailRoute,
    reinsuranceCompanyChangePasswordRoute,
    insuranceCompanyRoute,
    insuranceCompanyShowRoute,
    policiesRoute,
    reportRoutes
];

export const auth = [];

export const unAuthRoutes = [loginRoute, forgotPasswordRoute];

export default [
    dashboardsRoutes,
    reinsuranceCompaniesRoutes,
    insuranceCompanyRoute,
    policiesRoute,
    reportRoutes,
    settingsRoute
];
